import { render, staticRenderFns } from "./CardArtwork.vue?vue&type=template&id=b1f08a02&scoped=true"
import script from "./CardArtwork.vue?vue&type=script&lang=js"
export * from "./CardArtwork.vue?vue&type=script&lang=js"
import style0 from "./CardArtwork.vue?vue&type=style&index=0&id=b1f08a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f08a02",
  null
  
)

export default component.exports